import React from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MainLayout from './components/MainLayout';
import Home from './pages/Home';
import SuccessPage from './pages/SuccessPage';
import CompanyDetails from './pages/CompanyDetails';
import Faq from './pages/Faq';
import RelocationCompanies from './pages/RelocationCompanies';
import TaskBoard from './pages/TaskBoard';
import VisaPage from './pages/public/VisaPage';

// Importando as novas telas de planos e redirecionamentos
import SubscriptionPlans from './pages/SubscriptionPlans';
// import PaymentMethodSelector from './components/PaymentMethodSelect';
import CadastroClientePage from './pages/private/clients/CadastroClientePage';
import GerenciamentoClientesPage from './pages/private/clients/GerenciamentoClientePage';
import EdicaoClientePage from './pages/private/clients/EdicaoClientePage';
import CadastroImovelPage from './pages/private/realEstate/CadastroImovelPage';
import GerenciamentoImoveisPage from './pages/private/realEstate/GerenciamentoImovelPage';
import ProfilePage from './pages/private/profile/ProfilePage';
import Login from './pages/public/Login';
import SingUp from './pages/public/SingUp';
import CadastroRealocationPage from './pages/private/realocations/CadastroRealocationPage';
import EditarImovelPage from './pages/private/realEstate/EditarImovelPage';
import GerenciamentoRealocacoesPage from './pages/private/realocations/GerenciamentoRealocacoesPage';
import EditarRealocacaoPage from './pages/private/realocations/EditarRealocacaoPage';
import Dashboard from './pages/private/dashboard/Dashboard';
import RelocationForm from './components/companies/RelocationForm';
import PremiumContactPage from './pages/public/PremiumContactPage';
import Checkout from './pages/private/checkout/checkoutPage.';
import SuccessCheckoutPage from './pages/private/checkout/SuccessPage';
import RelocationEmailForm from './components/companies/RelocationEmailForm';
import AboutUsPage from './pages/public/AboutUsPage';
import PoliticaPrivacidade from './pages/public/PoliticaPrivacidadePage';
import ForgotPassword from './pages/public/ForgotPasswordPage';
import ResetPassword from './pages/public/ResetPasswordPage';

const AppContent = () => {
  const location = useLocation();

  // Lista de rotas que **não** devem exibir o Footer
  const noFooterRoutes = [
    '/dashboard',
    '/realocation/register-realocation',
    '/realocation-history',
    '/realocation-imovel',
    '/realocation-client',
    '/tasks',
    '/profile',
    '/login',
    '/realocation/client-register',
    '/realocation/client-management',
    '/realocation/client-update',
    '/sign-up',
    '/clients/register',
    '/clients/management',
    '/clients-update/:email',
    '/real-estate/register',
    '/real-estate/management',
    '/realocation/register',
    '/realocation/history',
    '/realocation/management',
    '/real-estate/update/:title',
    '/realocation/editar/:id',
    '/payment',
    '/payment/success',
    '/realocation/editar/',
    '/forgot-password',
    '/reset-password/',
    '/reset-password/:token',

  ];

  // Verifica se o Footer deve ser exibido com base na rota atual
const shouldRenderFooter = !noFooterRoutes.some((route) =>
  route.includes(':') ? location.pathname.startsWith(route.split('/:')[0]) : route === location.pathname
);

  return (
    <>
      <Routes>
        {/* Rotas com Header */}
        <Route path="/" element={<><Header /><Home /></>} />
        <Route path="/relocation-companies" element={<><Header /><RelocationCompanies /></>} />
        <Route path="/company-details/:companyId" element={<><Header /><CompanyDetails /></>} />
        <Route path="/visa-info" element={<><Header /><VisaPage /></>} />
        <Route path="/faq" element={<><Header /><Faq /></>} />
        <Route path="/sign-up" element={<SingUp />} />
        <Route path="/success" element={<><Header /><SuccessPage /></>} />
        <Route path="/information-company" element={<><Header />{/* Sua tela de cadastro de empresa */}</>} />
        <Route path="/login" element={<Login />} />
        
         <Route path="/forgot-password" element={<ForgotPassword />} />
         <Route path="/reset-password/:token" element={<ResetPassword />} />


        <Route path="/relocation-form" element={<><Header /><RelocationForm /></>} />
        <Route path="/contact" element={<><Header /><PremiumContactPage /></>} />
        <Route path="/about-us" element={<><Header /><AboutUsPage /></>} />
        <Route path="/politica-privacidade" element={<><Header /><PoliticaPrivacidade /></>} />



        {/* Novas rotas para os planos */}
        <Route path="/subscription-plans" element={<><Header /><SubscriptionPlans /></>} />
        {/* <Route path="/checkout-profissional" element={<><Header /><CheckoutProfissional /></>} /> */}
        {/* <Route path="/payment-methods" element={<><Header /><PaymentMethodSelector /></>} /> */}

        <Route path="/relocation-questionnaire" element={<><Header /><RelocationEmailForm /></>} />


        {/* Rotas para páginas com Sidebar */}
        <Route
          path="/dashboard"
          element={
            <MainLayout>
              <Dashboard />
            </MainLayout>
          }
        />
        <Route
          path="/realocation/register"
          element={
            <MainLayout>
              <CadastroRealocationPage />
            </MainLayout>
          }
        />
        <Route
          path="/realocation/management"
          element={
            <MainLayout>
              <GerenciamentoRealocacoesPage />
            </MainLayout>
          }
        />
        <Route
          path="/realocation/editar/:id"  // Note o prefixo "realocation" (com 'a')
          element={
            <MainLayout>
              <EditarRealocacaoPage />
            </MainLayout>
          }
        />
        <Route
          path="/real-estate/register"
          element={
            <MainLayout>
              <CadastroImovelPage />
            </MainLayout>
          }
        />

        <Route
          path="/real-estate/management"
          element={
            <MainLayout>
              <GerenciamentoImoveisPage />
            </MainLayout>
          }
        />
        <Route
          path="/real-estate/update/:title"
          element={
            <MainLayout>
              <EditarImovelPage />
            </MainLayout>
          }
        />


        <Route
          path="/clients/register"
          element={
            <MainLayout>
              <CadastroClientePage />
            </MainLayout>
          }
        />
        <Route
          path="/payment"
          element={
            <MainLayout>
              <Checkout />
            </MainLayout>
          }
        />

        <Route
          path="/payment/success"
          element={
            <MainLayout>
              <SuccessCheckoutPage />
            </MainLayout>
          }
        />
        <Route
          path="/clients/management"
          element={
            <MainLayout>
              <GerenciamentoClientesPage />
            </MainLayout>
          }
        />
        <Route
          path="/clients-update/:email"
          element={
            <MainLayout>
              <EdicaoClientePage />
            </MainLayout>
          }
        />
        <Route
          path="/tasks"
          element={
            <MainLayout>
              <TaskBoard />
            </MainLayout>
          }
        />

        <Route
          path="/profile"
          element={
            <MainLayout>
              <ProfilePage />
            </MainLayout>
          }
        />
      </Routes>

      {/* Renderiza o Footer apenas se necessário */}
      {shouldRenderFooter && <Footer />}
    </>
  );
};

const AppRoutes = () => (
  <Router>
    <AppContent />
  </Router>
);

export default AppRoutes;
